module.exports = __webpack_public_path__ + "img/biohazard-sign.31918db9.png";